import { render, staticRenderFns } from "./medicine_analysis.vue?vue&type=template&id=b425d988&scoped=true"
import script from "./medicine_analysis.vue?vue&type=script&lang=js"
export * from "./medicine_analysis.vue?vue&type=script&lang=js"
import style0 from "./medicine_analysis.vue?vue&type=style&index=0&id=b425d988&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b425d988",
  null
  
)

export default component.exports